/* eslint-disable @typescript-eslint/no-unused-vars */
import { Timeline } from "@material-ui/lab";
import React, { useEffect, useState } from "react";

// import color from "../../../../constants/color";
// import icons from "../../../../constants/icons";
// import warn from "../../../../constants/toast";
// import MaterialUI from "../../../../material-UI";
import CardHistorico from "../../../../screens/lead/components/cardHistorico/cardHistorico.component";
import axiosLead from "../../../../services/lead";
import * as Styles from "../../styles";

interface Props {
  idLead: string;
  idLeadCorretor: string;
  onClose: Function;
  open: boolean;
}

interface History {
  nomeLog: string;
  dataHoraAcao: string;
  corretorRealizacaoAcao: string;
  urlFotoCorretorRealizacaoAcao: string;
}

interface HistoricParams {
  tipoLogLead: number | undefined;
}

const Historic: React.FC<Props> = ({ idLeadCorretor, onClose, open }) => {
  const [historyLead, setHistoryLead] = useState<History[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [historicParams, setHistoricParams] = useState<HistoricParams>({
    tipoLogLead: 0,
  });

  useEffect(() => {
    getHistory();
  }, [historicParams]);

  useEffect(() => {
    setLoading(true);
    Promise.all([getHistory()])
      .then(() => {
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  }, []);

  const getHistory = async () => {
    try {
      const response = await axiosLead.GetLogs(idLeadCorretor, historicParams);
      setHistoryLead(response.data.data);
    } catch (error: any) {
      console.log(
        error?.response?.data?.notifications
          ? error?.response?.data?.notifications?.map(
              (item: any) => `${item.message}\n`
            )
          : "Erro ao listar histórico"
      );
    }
  };

  const handleHistoricFilter = (value: number) => {
    setHistoricParams({ tipoLogLead: value });
  };

  const timeLine = () => (
    <Timeline align="left" style={{ alignItems: "center", height: 600 }}>
      {historyLead.length < 1 ? (
        <Styles.Text style={{ textAlign: "center", marginTop: 35 }}>
          Sem histórico para esse Lead
        </Styles.Text>
      ) : (
        historyLead.map((item: any) => (
          <CardHistorico
            codigoTipoLogLead={item.codigoTipoLogLead}
            idCorretorRealizacaoAcao={item.idCorretorRealizacaoAcao}
            idLead={item.idLead}
            idLeadCorretor={item.idLead}
            idTipoLogLead={item.idTipoLogLead}
            nome={item.nome}
            valores={item.valores}
            nomeCorretor={item.nomeCorretor}
            nomeFotoCorretor={item.nomeFotoCorretor}
            dataAtualizacao={item.dataAtualizacao}
            nomeStatusTarefa={item.nomeStatusTarefa}
            nomeTipoTarefa={item.nomeTipoTarefa}
            observacao={item.observacao}
            nomeMotivoDesqualificacaoLead={item.nomeMotivoDesqualificacaoLead}
            nomeCorretorDestino={item.nomeCorretorDestino}
            isTable
          />
        ))
      )}
    </Timeline>
  );

  return (
    <>
      <Styles.FormControl size="small">
        <Styles.Select
          color="secondary"
          value={historicParams?.tipoLogLead}
          label="Status"
          variant="outlined"
          onChange={(event: any) => {
            handleHistoricFilter(event.target.value);
          }}
          className="select-historic"
          MenuProps={{
            anchorOrigin: {
              vertical: "bottom",
              horizontal: "left",
            },
            getContentAnchorEl: null,
          }}
        >
          <Styles.MenuItemSelect value={0}>Todos</Styles.MenuItemSelect>
          <Styles.MenuItemSelect value={1}>Alteração</Styles.MenuItemSelect>
          <Styles.MenuItemSelect value={2}>Tarefas</Styles.MenuItemSelect>
          <Styles.MenuItemSelect value={3}>Etapa</Styles.MenuItemSelect>
          <Styles.MenuItemSelect value={4}>
            Desqualificação
          </Styles.MenuItemSelect>
          <Styles.MenuItemSelect value={5}>
            Compartilhamento
          </Styles.MenuItemSelect>
          <Styles.MenuItemSelect value={6}>Transferência</Styles.MenuItemSelect>
        </Styles.Select>
      </Styles.FormControl>
      {timeLine()}
      <Styles.Footer>
        <Styles.ButtonClose disabled={false} onClick={() => onClose(!open)}>
          Fechar
        </Styles.ButtonClose>
      </Styles.Footer>
    </>
  );
};
export default Historic;
